import styled from 'styled-components';

export const RootContainer = styled.div`
 background: #f9f9f9;
 padding-top:60px;
 @media (max-width: 767px) {
    padding-top:36px;
  }
 .partner-heading{
    padding-bottom: 24px;
 }
 .filter-row{
    display: flex;
    gap: 20px;
    align-items: flex-start;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 28px;
      margin-bottom:28px;
    }
  }
`;
export const RightRootElement = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;
  margin-left: auto;
  flex: none;
  padding-top: 3px;
  .filter-totalPartners {
    display: flex;
    gap: 4px;
  };
  @media (max-width: 767px) {
      width: 100%;
      justify-content: space-between;
  }
`;
export const FilterListingContainer = styled.div`
&.display-flex{
  display: flex;
  @media (max-width: 1040px) {
    display: flex;
    @media (max-width: 767px) {
      display: block;
    }
  }
}
.filter-section {
    height: 100%;
    overflow: hidden;
    transition: width 1s ease-in-out, height 1s ease-in-out;
    padding-top:48px;
    width:273px;
    flex: none;
}
.filter-section.animation {
    padding-bottom: 0;
    height: 0;
    width: 0;
}
    .card-section.filter-active{    
      width: calc(100% - 273px);
      padding-left:36px;
      .grid-col{
            grid-template-columns: 1fr 1fr 1fr;
            @media (max-width: 1040px) {
              grid-template-columns: 1fr 1fr;
              @media (max-width: 767px) {
                  grid-template-columns: 1fr;
              }
            }
        }
    }
`;
